__turbopack_context__.v({
  "animated-loader-svg": "loader-module__5ZBgQW__animated-loader-svg",
  "spin": "loader-module__5ZBgQW__spin",
});
